import React from 'react';

import { Grid, LegacyTextList, Typography } from '@gogame/components';
import { ConfirmDialog } from '@gogame/components';
import { useMutation } from '@gogame/query';
import { useScreenModalV2 } from '@gogame/screens';

import { changeCampaignsStatus } from 'scenes/Campaigns/sources/campaigns';

import { activate } from '../queryKeyFactory';

export const useActivateCampaigns = () => {
  const showModal = useScreenModalV2(ConfirmDialog);
  const activateCMNMutation = useMutation(activate(), changeCampaignsStatus);

  const handleAction = async ({ status, campaigns }) => {
    const campaignNames = campaigns.map(({ name }) => name);
    const campaignIds = campaigns.map(({ id }) => id);

    await showModal({
      title: 'Activate Campaign(s)?',
      confirmActionLabel: 'Activate',
      children: (
        <React.Fragment>
          <Typography color={'textSecondary'}>Campaign</Typography>
          <Grid container direction={'column'}>
            <LegacyTextList
              data={campaignNames}
              limit={1}
              unitsName={'Campaigns'}
              position={'top'}
            />
          </Grid>
        </React.Fragment>
      ),
    });
    await activateCMNMutation.mutateAsync({ status, campaignIds });
  };

  return [handleAction, activateCMNMutation];
};
